import { useFormik } from 'formik';
import { useEffect, useMemo } from 'react';
import { globalOption } from '../../../../../components/muiLegacy/Autocomplete/VoxelAutocompleteCountry';
import { allLanguagesOption } from '../../../../../components/muiLegacy/Autocomplete/VoxelAutocompleteLanguage';
import { GoogleAdsRequestGq } from '../../../../../graphql/projects/models/GoogleAdsRequestGq';
import { languageList } from '../../../../../graphql/projects/models/languages';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import { CreateQuickSearchFormState } from '../QuickSearchForm/logic/QuickSearchModels';

export function setupSearchInfoForm(input: {
  selectedProjectId?: number;
  selectedRequestId?: number;
  selectedRequest?: GoogleAdsRequestGq;
}) {
  const {
    selectedProjectId,
    selectedRequestId,
    selectedRequest,
  } = input;

  // Historic data (if a request is selected)
  const historicApiCollectionQuery = projectsApiService.queries.googleAds.useGetGoogleAdsRequest(
    {
      id: selectedRequestId,
      projectId: selectedProjectId,
    },
    { skip: !selectedRequestId || !selectedProjectId }
  );

  const historicApiCallsQuery = projectsApiService.queries.googleAds.useGetGoogleAdsRequestBatches(
    {
      requestId: selectedRequestId as number,
      page: 1,
      itemsPerPage: 100,
      projectId: selectedProjectId,
    },
    { skip: !selectedRequestId || !selectedProjectId }
  );

  const historicCategoriesQuery = projectsApiService.queries.googleAdWords.useGetCategories();
  const historicSource = selectedRequest?.searchSource ?? historicApiCallsQuery?.result?.batches?.map((apiCall) => apiCall.source).join('\n');
  const historicSourceIds = selectedRequest?.searchSourceIds?.length ? selectedRequest?.searchSourceIds : historicApiCallsQuery?.result?.batches?.map((apiCall) => apiCall.sourceId);

  const apiCollection = historicApiCollectionQuery?.result?.request;
  const apiLocationsQuery = projectsApiService.queries.googleAds.useGetLocations({ id: apiCollection?.locationId });
  const apiVolumeLocation = useMemo(() => apiLocationsQuery?.result ? apiLocationsQuery?.result[0] : globalOption, [apiLocationsQuery?.result]);
  const countryQuery = projectsApiService.queries.googleAds.useGetLocations({ targetType: 'Country' });


  // Initial values (default)
  let initialValues: CreateQuickSearchFormState = {
    requestType: apiCollection?.googleAdsRequestType,
    requestName: apiCollection?.name,
    language: languageList?.find((language) => language.id === apiCollection?.languageId) ?? allLanguagesOption,
    country: !apiVolumeLocation?.id ? globalOption : apiVolumeLocation?.targetType === 'City' ? countryQuery?.result?.find((l) => l.countryCode === apiVolumeLocation?.countryCode) : apiVolumeLocation,
    city: apiVolumeLocation?.targetType === 'City' ? apiVolumeLocation : null,
    includeZeroVolume: false,
    includeMonths: apiCollection?.minSearchVolume === 0,
    source: historicSource ?? '',
    categories: historicSourceIds
      ?.map((sourceId) =>
        historicCategoriesQuery?.result?.find((category) => category.id === sourceId)
      )
      ?.filter((category) => !!category) ?? [],
    suggestionsWord: apiCollection?.suggestionsWord ?? true,
    suggestionsAlphabeticals: apiCollection?.suggestionsAlphabeticals ?? true,
    suggestionsNumbers: apiCollection?.suggestionsNumbers ?? true,
    suggestionsComparisons: apiCollection?.suggestionsQuestions,
    suggestionsPrepositions: apiCollection?.suggestionsPrepositions,
    suggestionsQuestions: apiCollection?.suggestionsComparisons,
  };

  const formBag = useFormik<CreateQuickSearchFormState>({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: (values, actions) => undefined,
  });

  // Update quick search type
  useEffect(() => {
    !!formBag.values.requestType?.length &&
      localStorage.setItem('quick_request_type', formBag.values.requestType);
  }, [formBag.values.requestType]);

  return formBag;
}
